// extracted by mini-css-extract-plugin
module.exports = {"editContainer":"EditShelf-editContainer-RWe-5O","editContent":"EditShelf-editContent-2Daa3x","editTop":"EditShelf-editTop-2f0Ujr","spinner":"EditShelf-spinner-7qwsVJ"};